"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getInstallationDetails = getInstallationDetails;
exports.getInstallationsInfo = getInstallationsInfo;
var _RestHelper = _interopRequireDefault(require("../utils/RestHelper"));
function getInstallationsInfo() {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/feedin/v0/installations"));
}
function getInstallationDetails(selected) {
  // eslint-disable-next-line no-underscore-dangle
  return _RestHelper.default.get(selected._links.self.href);
}
var _default = exports.default = {
  getInstallationsInfo: getInstallationsInfo
};